import axios from 'axios';

import config from '../config/api.json';
import TextUtil from "../util/TextUtil";

export default async function getViewData(viewName, lang, onDataReceived, port,
                                          token, date) {
    const headers = token ? {'X-WP-Nonce': token,} : {};
    const withCredentials = !!token;
    const datePath = date && token ? '/' + date : '';
    const langPath = lang ? '/' + lang : '';
    let url = config.api_base + config.entry_path + viewName +
        langPath + datePath;
    if (viewName === "dpaposts") {
        url = config.api_base + config.dpa_path;
    } else if (viewName === "uestra/dpa-sportlive-table") {
        url = config.api_base + config.dpa_table_path;
    } else if (viewName === "uestra/dpa-sportlive-matches") {
        url = config.api_base + config.dpa_matches_path;
    }
    if (port && port !== 0) {
        if (viewName === "dpaposts") {
            url = "http://127.0.0.1:" + port + "/api" + config.dpa_path;
        } else if (viewName === "uestra/dpa-sportlive-table") {
            url = "http://127.0.0.1:" + port + "/api" + config.dpa_table_path;
        } else if (viewName === "uestra/dpa-sportlive-matches") {
            url = "http://127.0.0.1:" + port + "/api" + config.dpa_matches_path;
        } else {
            url = "http://127.0.0.1:" + port + "/api" + config.entry_path + viewName;
        }
        //console.log(url);
    }
    const response = await axios.get(url, {
        headers: headers,
        withCredentials: withCredentials,
        transformResponse: [(data) => {
            return data
        }],
    });
    if (response && 200 === response.status && response.data) {
        const lastModified = response.headers['last-modified'];
        if (viewName === "dpaposts") {
            let dpa = JSON.parse(response.data);
            let result = [];
            for (let entry of dpa) {
                if (checkDpaEntry(entry)) {
                    result.push(entry);
                }
            }
            onDataReceived(result, lastModified);

        } else {
            onDataReceived(JSON.parse(response.data), lastModified);
        }
    } else {
        throw new Error('request failed', response);
    }
}

function checkDpaEntry(entry) {
    if (entry.kacheln.length <= 1) {
        return false;
    }
    let hasArticle = false
    for (let kachel of entry.kacheln) {
        if (kachel.type === "uestra/dpa-infoline-entry") {
            hasArticle = true;
            if (TextUtil.isEmptyText(kachel.title)) {
                return false;
            }
            if (TextUtil.isEmptyText(kachel.teaser)) {
                return false;
            }
            if (TextUtil.isEmptyText(kachel.kicker)) {
                return false;
            }
        }

    }
    return hasArticle;
}
